import React from 'react';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-green-50 h-1/2 py-8 px-2 md:px-0">
      {/* 主內容卡片 */}
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8">
        <h1 className="text-3xl md:text-4xl font-bold text-green-900 mb-6 border-b pb-2">
          {t('home.hero.title')}
        </h1>
        <h2 className="text-xl font-semibold text-green-800 mb-4">什麼是慢性阻塞性肺病（COPD）？</h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          慢性阻塞性肺病（COPD, Chronic Obstruction Pulmonary Disease）是一種常見的慢性呼吸道疾病，主要特徵為氣流受限且不可逆轉。常見症狀包括長期咳嗽、咳痰及呼吸困難。COPD 主要由吸菸、空氣污染等因素引起。
        </p>
        <h2 className="text-xl font-semibold text-green-800 mb-2">COPD 的成因</h2>
        <ul className="list-disc pl-6 mb-4 text-gray-700">
          <li>長期吸菸</li>
          <li>空氣污染</li>
          <li>職業性粉塵或化學物質暴露</li>
          <li>遺傳因素</li>
        </ul>
        <h2 className="text-xl font-semibold text-green-800 mb-2">如何預防與照護</h2>
        <ul className="list-disc pl-6 text-gray-700">
          <li>戒菸，避免二手菸</li>
          <li>保持良好生活環境，減少空氣污染暴露</li>
          <li>規律運動，增強肺功能</li>
          <li>遵循醫囑，定期追蹤治療</li>
        </ul>
      </div>
    </div>
  );
};

export default Home; 